// Libraries
import axios from 'axios';

const instance = axios.create();

/*
const instance = axios.create({
    baseURL: 'http://gemini.test/api/v1/'
});
*/
instance.interceptors.request.use(
    async (config) => {
        const token = localStorage.getItem('bearerToken');
        let bearer = '';
        if (token) {
            bearer = token;
        }
        if (bearer !== ''){
            config.headers.set('Authorization', `Bearer ${token}`);
        }
        return config;
    },
    (err) => {
        return Promise.reject(err);
    }
);

export default instance;